(() => {
  if (window.NiPASafeVariantSyncLoaded) return;
  window.NiPASafeVariantSyncLoaded = true;

  const ADD = 'Añadir al carrito';
  const SOLD = 'Temporalmente agotada';
  const UNAVAILABLE = 'Combinación no disponible';
  const formatPrice = (priceInCents) => {
    const amount = Number(priceInCents) / 100;
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : 'MXN';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {
        style: 'currency',
        currency
      }).format(amount);
    } catch (error) {
      return '$ ' + amount.toFixed(2);
    }
  };
  let productData = null;
  let productRequest = null;

  const productHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  const loadProduct = () => {
    if (productData) return Promise.resolve(productData);
    if (productRequest) return productRequest;
    const handle = productHandle();
    if (!handle) return Promise.resolve(null);

    productRequest = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((product) => {
        productData = product;
        return product;
      })
      .catch(() => null);

    return productRequest;
  };

  const optionValues = (productId) => {
    const optionsRoot = document.querySelector(`product-options-element[data-id="${CSS.escape(productId)}"]`);
    if (!optionsRoot) return [];

    const dropdownInputs = Array.from(optionsRoot.querySelectorAll('.disclosure--input'));
    if (dropdownInputs.length) return dropdownInputs.map((input) => input.value);

    return Array.from(optionsRoot.querySelectorAll('.radios--container, .swatches--container')).map((group) => {
      const checked = group.querySelector('input:checked');
      return checked ? checked.value : '';
    });
  };

  const findVariant = (product, values) => {
    if (!product || !Array.isArray(product.variants) || !values.length || values.some((value) => !value)) return null;

    return product.variants.find((variant) => {
      const variantOptions = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return variantOptions.length === values.length && variantOptions.every((value, index) => String(value) === String(values[index]));
    }) || null;
  };

  const setButton = (button, text, disabled) => {
    if (!button) return;
    button.disabled = disabled;
    button.dataset.text = text;
    const label = button.querySelector('.product-buy-buttons--cta-text, span:not(.product-buy-buttons--spinner)');
    if (label) label.textContent = text;
  };

  const applyVariant = (buyRoot, variant) => {
    if (!buyRoot || !variant) return;

    const available = variant.available === true;
    const text = available ? ADD : SOLD;

    buyRoot.querySelectorAll('.product-buy-buttons--primary').forEach((button) => {
      setButton(button, text, !available);
    });

    const input = buyRoot.querySelector('input.product-buy-buttons--input[name="id"]');
    if (input) {
      input.value = String(variant.id);
      input.dataset.id = String(variant.id);
      input.dataset.sku = variant.sku || '';
    }

    const note = buyRoot.querySelector('.nipa-soldout-note');
    if (note) {
      note.dataset.visible = available ? 'false' : 'true';
      note.setAttribute('aria-hidden', available ? 'true' : 'false');
    }

    const smartPayment = buyRoot.querySelector('.product-buy-buttons--smart');
    if (smartPayment) {
      smartPayment.hidden = !available;
      smartPayment.setAttribute('aria-hidden', available ? 'false' : 'true');
      smartPayment.style.display = available ? '' : 'none';
    }

    const drawerVariant = buyRoot.querySelector('.product-buy-buttons--drawer-variant');
    if (drawerVariant) drawerVariant.textContent = variant.title || '';

    const stickyPrice = buyRoot.querySelector('.nipa-sticky-price');
    if (stickyPrice && Number.isFinite(Number(variant.price))) {
      stickyPrice.textContent = formatPrice(variant.price);
    }
  };

  const sync = async () => {
    const product = await loadProduct();
    if (!product) return;

    document.querySelectorAll('product-buy-buttons-element[data-id]').forEach((buyRoot) => {
      const values = optionValues(buyRoot.dataset.id);
      const variant = findVariant(product, values);
      if (variant) applyVariant(buyRoot, variant);
    });
  };

  const scheduleSync = () => {
    sync();
    window.requestAnimationFrame(sync);
    [80, 220, 500, 1000].forEach((delay) => window.setTimeout(sync, delay));
  };

  const registerThemeEvents = () => {
    document.querySelectorAll('product-buy-buttons-element[data-id]').forEach((root) => {
      const productId = root.dataset.id;
      if (!productId || root.dataset.nipaEventRegistered === 'true') return;
      root.dataset.nipaEventRegistered = 'true';
      window.addEventListener(`theme:product:${productId}:variantChanged`, scheduleSync);
    });
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest('product-options-element')) return;
    scheduleSync();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const buyRoot = form && form.querySelector ? form.querySelector('product-buy-buttons-element[data-id]') : null;
    if (!buyRoot || !productData) return;

    const variant = findVariant(productData, optionValues(buyRoot.dataset.id));
    if (!variant) return;

    const input = buyRoot.querySelector('input.product-buy-buttons--input[name="id"]');
    if (input) input.value = String(variant.id);

    if (!variant.available) {
      event.preventDefault();
      applyVariant(buyRoot, variant);
    }
  });

  const start = () => {
    registerThemeEvents();
    loadProduct().then(scheduleSync);
  };

  window.addEventListener('pageshow', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();